import { getRemoHosts } from "config";
import logger from "logging/logger";
import companyApi from "modules/company/company.api";
import { setBrandName } from "modules/settings/redux/slice";
import { useEffect } from "react";
import { useAppDispatch } from "store/hooks";

export const BrandNameLoader = () => {
  const dispatch = useAppDispatch();
  const isRemoDomain = getRemoHosts().includes(window.location.host);

  useEffect(() => {
    if (!isRemoDomain) {
      const fetchCustomDomainCompanyName = async () => {
        try {
          const result = await companyApi.getCustomDomainCompanyName(
            window.location.host,
          );

          dispatch(setBrandName(result.companyName));
        } catch (error) {
          logger.error(
            "[BrandNameLoader] Error fetching custom domain company name",
            { error },
          );
        }
      };

      fetchCustomDomainCompanyName();
    }
  }, [dispatch, isRemoDomain]);

  return null;
};
